<template>
  <q-form padding class="row q-px-md" @submit="save" v-bind="$attrs">
    <slot></slot>
  </q-form>
</template>

<script setup>
import { computed, defineEmits, defineExpose, defineProps } from "vue";

const props = defineProps({ edit: { type: Boolean, default: false }, new: { type: Boolean, default: false }  });

const edit = computed(() => props.edit);
const isNew = computed(() => props.new);
defineExpose({ edit, isNew });

const emit = defineEmits(["save"]);
const save = () => emit("save");

</script>

